import { useQuery } from 'react-query'
import axiosClient from '~/api/axiosClient'
import { SsoUriResponse } from '~/models/Login.model'

export const LoginService = (source : string, query : string) => {
  const ssoApiURLService = useQuery(
    [],
    () => axiosClient.get(`/api/dt/Users/GetSSOURL?source=${source ?? ''}&query=${encodeURI(query ?? '')}`) as unknown as Promise<SsoUriResponse>
  )

  return { ssoApiURLService }
}
